/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { DataRest, InvitationsListData } from '../model/api/data-rest';
import { resources } from './api';
import { ThermoGroupInvitation } from '../model/thermo';
import { DeviceInvitation } from '../model/device';


@Injectable({
    providedIn: 'root'
})
export class InvitationsService {

    constructor(
        private http: HttpClient
    ) { }

    getInvitationsList(pending?: boolean, type?: number):
        Observable<InvitationsListData> {
        let params = new HttpParams();
        if (pending !== undefined) {
            params = params.set('pending', pending);
        }
        if (type !== undefined) {
            params = params.set('type', type);
        }
        console.log(params);
        return this.http.get<InvitationsListData>(`${environment.apiUrl}${resources.get('invitations')}`, { params });
    }


    invitationsShareDevice(deviceInvitation: DeviceInvitation, userId?: number): Observable<DataRest> {
        const payload = {
            Email: deviceInvitation.email,
            FirstName: deviceInvitation.firstName,
            LastName: deviceInvitation.lastName,
            DeviceId: deviceInvitation.deviceId,
            RemotesMax: deviceInvitation.remotesMax
        };
        let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}`, payload, {params});
    }

    invitationsAccept(token: string,): Observable<DataRest> {
        const payload = {};
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}/${token}${resources.get('accept')}`, payload);
    }

    invitationsReject(token: string,): Observable<DataRest> {
        const payload = {};
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}/${token}${resources.get('reject')}`, payload);
    }

    invitationsThGroupShare(thermoGroupInvitation: ThermoGroupInvitation, userId?: number): Observable<DataRest> {
        const payload = {
            Email: thermoGroupInvitation.email,
            FirstName: thermoGroupInvitation.firstName,
            LastName: thermoGroupInvitation.lastName,
            GroupId: thermoGroupInvitation.groupId,
        };
        let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('invitations')}`, payload, { params });
    }
}
